/**
 * User status
 */
export enum UserStatus {
    PENDING  = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED'
}
